import {
  getDocs,
  query,
  orderBy,
  limit,
  doc,
  startAfter,
  collection,
  setDoc,
  where,
  getDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { useState, useEffect } from "react";
import "../../Resources/Css/sub.css";
import { Inquiry } from "../Support/inquiry";

// 게시글 삭제
export async function DeleteThisPost(table, post) {
  if (!window.confirm("Are you sure you want to delete it?")) {
    return false;
  }
  try {
    const docRef = doc(db, table, post);
    await deleteDoc(docRef);
    window.alert("Post has been deleted.");
    if (table === "inform") {
      window.location.href = "/community/inform";
    } else if (table === "news") {
      window.location.href = "/community/news";
    } else if (table === "hiring") {
      window.location.href = "/community/hiring";
    } else if (table === "faq") {
      window.location.href = "/support/faq";
    } else if (table === "inquiry") {
      window.location.href = "/support/inquiry";
    } else if (table === "popup") {
      window.location.href = "/popup";
    }
    return true;
  } catch (error) {
    console.log("삭제실패", error);
    return false;
  }
}

// 댓글 등록
export async function SendComment(table, post, commentData) {
  try {
    const docRef = doc(collection(db, table, post, "comments"));
    await setDoc(docRef, { commentData });
  } catch (error) {
    // console.log("댓글등록 오류", error);
    return false;
  }

  return true;
}

// 댓글 수정
export async function ModifyComment(table, post, commentId, commentData) {
  try {
    const docRef = doc(db, table, post, "comments", commentId);
    await updateDoc(docRef, { commentData });
    return true;
  } catch (error) {
    // console.log("수정된 댓글 저장 오류: ", error);
    return false;
  }
}

// 댓글 삭제
export async function DeleteComment(table, post, commentId) {
  try {
    const docRef = doc(db, table, post, "comments", commentId);
    await deleteDoc(docRef);
    return true;
  } catch (error) {
    // console.log("댓글 삭제 오류: ", error);
    return false;
  }
}

// 비밀번호 확인
export async function CheckPW(post, password) {
  // console.log(post);
  // console.log(password);

  const docRef = doc(db, "inquiry", post);

  const snapshot = await getDoc(docRef);

  if (!snapshot.exists()) {
    return false;
  }

  const docData = snapshot.data();
  // console.log(docData.secret);

  if (docData.secret == password) {
    return true;
  } else {
    return false;
  }
}

// 팝업 갯수변경
export async function ChangeShowPopup(num) {
  console.log("받아온 갯수: ", num);
  try {
    const countRef = doc(db, "popupCount", "popupCount1");
    await updateDoc(countRef, { count: num });

    return true;
  } catch (error) {
    // console.log("팝업 갯수 설정 오류: ", error);
    return false;
  }
}

// 해당 팝업 활성화/비활성화 설정
export async function ChangePopupToggle(popup) {
  try {
    const docRef = doc(db, "popup", popup.id);
    if (popup.popup_yn == "Y") {
      await updateDoc(docRef, { popup_yn: "N" });
      return true;
    } else if (popup.popup_yn == "N") {
      await updateDoc(docRef, { popup_yn: "Y" });
      return true;
    }
  } catch (error) {
    // console.log("팝업 활성화 토글 오류: ", error);
    return false;
  }
}
